// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taskInputBox .historyInput {
  width: 350px;
  max-width: 400px;
}
.taskInputBox .historyInput:disabled {
  color: white;
}

.searchInput input {
  padding: 10px 20px;
}
.searchInput label {
  top: -5px;
  font-size: 14px;
}
.searchInput label.MuiFormLabel-filled {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.searchInput label.Mui-focused {
  top: 4px;
  left: 4px;
  font-size: 12px;
}

.serch_paginate {
  margin: 3px;
}`, "",{"version":3,"sources":["webpack://./src/pages/service/service.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,gBAAA;AAAR;AAGI;EACI,YAAA;AADR;;AAME;EACE,kBAAA;AAHJ;AAME;EACE,SAAA;EACA,eAAA;AAJJ;AAOE;EACE,QAAA;EACA,SAAA;EACA,eAAA;AALJ;AAQE;EACE,QAAA;EACA,SAAA;EACA,eAAA;AANJ;;AAUA;EACE,WAAA;AAPF","sourcesContent":[".taskInputBox {\n    .historyInput {\n        width: 350px;\n        max-width: 400px;\n    }\n\n    .historyInput:disabled {\n        color: white;\n    }\n}\n\n.searchInput {\n  input {\n    padding: 10px 20px;\n  }\n\n  label {\n    top: -5px;\n    font-size: 14px;\n  }\n\n  label.MuiFormLabel-filled {\n    top: 4px;\n    left: 4px;\n    font-size: 12px;\n  }\n\n  label.Mui-focused {\n    top: 4px;\n    left: 4px;\n    font-size: 12px;\n  }\n}\n\n.serch_paginate {\n  margin: 3px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
